import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    title: _ctx.icon,
    class: _normalizeClass(["player-icon-image", [_ctx.classes, { thumbnail: _ctx.thumbnail }]]),
    style: _normalizeStyle(_ctx.imageStyle)
  }, null, 14, _hoisted_1))
}